import CubesAnim from "../Animation/CubesAnim";
import "./ReservationPage.css";
import Day from "./Day";
import { useState } from "react";
const ReservationPage = () => {
  const [clicks, setClicks] = useState({});

  const cbClick = (id) => {
    setClicks({
      [id]: true,
    });
  };

  let allowedClick = true;
  if (Object.keys(clicks).length > 0) {
    allowedClick = false;
  }

  let jsxDays = [];
  for (let i = 1; i <= 31; i++) {
    jsxDays.push(
      <Day
        color="white"
        key={i}
        bgColor="blue"
        classProps="daysNum"
        i={i}
        ownClick={clicks[i]}
        allowedClick={allowedClick}
        cb={cbClick}
      >
        {i}
      </Day>
    );
  }

  return (
    <div className="resPage_wrapper">
      <div className="datePicker_div">
        <div className="datePicker">
          <Day color="lightgrey">Tue</Day>
          <Day color="lightgrey">Wed</Day>
          <Day color="lightgrey">Thu</Day>
          <Day color="lightgrey">Fri</Day>
          <Day color="lightgrey">Sat</Day>
          <Day color="lightgrey">Sun</Day>
          <Day color="lightgrey">Mon</Day>
          {jsxDays}
          <Day color="red">1</Day>
          <Day color="red">2</Day>
          <Day color="red">3</Day>
          <Day color="red">4</Day>
        </div>
        <div className="moreInfo">
          <form method="POST">
            <input type="text" name="text" id="" placeholder="name" />
            <input type="text" name="text" id="" placeholder="surename" />
            <input type="text" name="text" id="" placeholder="proffesion" />
            <input type="text" name="text" id="" placeholder="reasons" />
            <button type="submit" onClick={(e) => e.preventDefault()}>submit</button>
          </form>
        </div>
        <div className="datePicker_txt">
          <h3>
            Choose a desirable date, and tell us some basic information about
            yourself, and we will contact you for the rest...
          </h3>
        </div>
        <i className="fas fa-caret-up"></i>
      </div>
      <CubesAnim />
    </div>
  );
};

export default ReservationPage;
